import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiButton, UiDialog } from 'ui-components';
import { borderLeft, marginLeft, marginRight } from 'utils';

export const StyledUiDialog = styled(UiDialog)(
  () => css`
    .MuiPaper-root {
      max-width: 800px !important;
    }
  `
);

export const StyledResetButton = styled(UiButton)(
  ({ theme }) => css`
    padding: 6px 16px !important;

    .icon {
      color: ${theme.palette.primary.light} !important;
    }
  `
);

export const StyledFiltersWrapper = styled('div')(
  ({ theme, hoverOnlyScrollbar = false }) => css`
    padding: 24px 0;
    ${borderLeft(`1px solid ${theme.palette.gray.light}`)}

    .header {
      display: flex;
      margin: 0 24px;
      align-items: center;
      gap: 8px;
      color: ${theme.palette.gray.darker};
      font-size: ${theme.typography.caption.fontSize};
      font-weight: ${theme.typography.caption.fontWeight};

      .icon {
        color: ${theme.palette.gray.darker};
        font-weight: 500;
      }
    }

    .body {
      height: 65vh;
      overflow-y: auto;
      ${marginRight('24px')}
      ${marginLeft('8px')}
        margin-top: 24px;

      ${hoverOnlyScrollbar &&
      css`
        &::-webkit-scrollbar {
          width: 8px;
        }

        &::-webkit-scrollbar-track {
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background: transparent;
        }

        &:hover {
          &::-webkit-scrollbar-thumb {
            background: ${theme.palette.gray.lighter};
          }

          &::-webkit-scrollbar-track {
            background: transparent;
          }
        }
      `}
    }
  `
);
